var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { tagMap } from '@cpsy-rmap-project/tags';
import _ from 'lodash';
import { PaperRepository } from '../repositories/paper';
import { formatPaper } from '../utils/paper';
export var generatePaperUrl = function (paperId, pathname) {
    if (pathname === void 0) { pathname = ''; }
    var baseUrl = (function () {
        var _a;
        var appEnv = (_a = process.env.REACT_APP_ENV) !== null && _a !== void 0 ? _a : process.env.APP_ENV;
        switch (appEnv) {
            case 'production':
                return 'https://ncnp-cpsy-rmap.web.app';
            case 'staging':
                return 'https://ncnp-cpsy-rmap-staging.web.app';
            case 'development':
                return 'https://ncnp-cpsy-rmap-development.web.app';
            default:
                throw new Error('想定外');
        }
    })();
    return baseUrl + "/" + pathname + "?id=" + paperId;
};
export var useUsecasePaper = function (_a) {
    var auth = _a.auth, firestore = _a.firestore;
    var paperRepository = new PaperRepository({ auth: auth, firestore: firestore });
    var existsSameDoi = function (_a) {
        var doi = _a.doi;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, paperRepository.existsSameDoi(doi)];
            });
        });
    };
    var addPaper = function (paper) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, paperRepository.addPaper(paper)];
        });
    }); };
    var editPaper = function (id, paper, uid) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, paperRepository.editPaper(id, paper, uid)];
        });
    }); };
    var editRequestPaper = function (id, originalPaper, editedPaper, user
    // eslint-disable-next-line max-params
    ) { return __awaiter(void 0, void 0, void 0, function () {
        var diffTexts, body, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    diffTexts = getEditedPaperDiffTexts(originalPaper, editedPaper, {
                        showOnlyDiff: true
                    });
                    if (diffTexts.length === 0) {
                        throw new Error('Nothing changes.');
                    }
                    body = "<!here> *\u4FEE\u6B63\u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u3042\u308A\u307E\u3059\u3002\u5BFE\u5FDC\u3057\u3066\u4E0B\u3055\u3044\u3002*\n- paper: " + generatePaperUrl(id) + "\n- user: " + user.displayName + "\n- email: " + user.email + "\n\n" + calcDiffText(diffTexts);
                    return [4 /*yield*/, fetch(process.env.REACT_APP_FUNCTIONS_URL + "/editRequest", {
                            method: 'POST',
                            body: body,
                            mode: 'cors'
                        })];
                case 1:
                    res = _a.sent();
                    if (!res.ok) {
                        throw new Error('edit request failure');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var deletePaper = function (paper) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, paperRepository.deletePaper(paper)];
        });
    }); };
    var outsideRequest = function (paperId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, paperRepository.outsideRequest(paperId)];
        });
    }); };
    var outside = function (paperId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, paperRepository.outside(paperId)];
        });
    }); };
    var inside = function (paperId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, paperRepository.inside(paperId)];
        });
    }); };
    return {
        addPaper: addPaper,
        editPaper: editPaper,
        editRequestPaper: editRequestPaper,
        deletePaper: deletePaper,
        existsSameDoi: existsSameDoi,
        outsideRequest: outsideRequest,
        outside: outside,
        inside: inside
    };
};
/** 変更差分検知のためのターゲット（一応Editフォームの表示順にする） */
var targetKeys = [
    'compMathMethodExperimentalDesign',
    'compMathMethodDataType',
    'compMathMethodModels',
    'unitOfAnalysis',
    'dsm5',
    'symptomatology',
    'rdocConstructs',
    'title',
    'authors',
    'year',
    'url',
    'journal',
    'abstract',
    'hypothesis',
    'prediction',
    'relevantPapers',
    'comment'
];
/** 変更差分を表示するための関数 */
export var getEditedPaperDiffTexts = function (originalPaper, editedPaper, options) {
    var shapedOriginalPaper = originalPaper
        ? formatPaper({
            paper: originalPaper
        })
        : undefined;
    var shapedEditedPaper = editedPaper
        ? formatPaper({
            paper: editedPaper
        })
        : undefined;
    if (JSON.stringify(_.pick(shapedOriginalPaper, targetKeys)) ===
        JSON.stringify(_.pick(shapedEditedPaper, targetKeys))) {
        return [];
    }
    return _.compact(targetKeys.map(function (key) {
        var _a, _b;
        var shapedOriginalPaperValue = shapedOriginalPaper === null || shapedOriginalPaper === void 0 ? void 0 : shapedOriginalPaper[key];
        var shapedEditedPaperValue = shapedEditedPaper === null || shapedEditedPaper === void 0 ? void 0 : shapedEditedPaper[key];
        if (key === 'rdocConstructs' ||
            key === 'unitOfAnalysis' ||
            key === 'dsm5' ||
            key === 'compMathMethodExperimentalDesign' ||
            key === 'compMathMethodDataType' ||
            key === 'compMathMethodModels' ||
            key === 'symptomatology') {
            var originalTagIds = (_a = shapedOriginalPaper === null || shapedOriginalPaper === void 0 ? void 0 : shapedOriginalPaper[key]) !== null && _a !== void 0 ? _a : [];
            var editedTagIds = (_b = shapedEditedPaper === null || shapedEditedPaper === void 0 ? void 0 : shapedEditedPaper[key]) !== null && _b !== void 0 ? _b : [];
            shapedOriginalPaperValue = originalTagIds
                .map(function (tagId) {
                var detailedTag = tagMap[tagId];
                if (detailedTag) {
                    return detailedTag.name;
                }
                return '';
            })
                .join(', ');
            shapedEditedPaperValue = editedTagIds
                .map(function (tagId) {
                var detailedTag = tagMap[tagId];
                if (detailedTag) {
                    return detailedTag.name;
                }
                return '';
            })
                .join(', ');
        }
        if ((options === null || options === void 0 ? void 0 : options.showOnlyDiff) &&
            shapedOriginalPaperValue === shapedEditedPaperValue) {
            return null;
        }
        return "\u30FB" + key + "\uFF1A \n  - " + (shapedOriginalPaperValue !== null && shapedOriginalPaperValue !== void 0 ? shapedOriginalPaperValue : '') + (shapedOriginalPaperValue === shapedEditedPaperValue
            ? ''
            : "\n    \u2192 \u3010" + (shapedEditedPaperValue !== null && shapedEditedPaperValue !== void 0 ? shapedEditedPaperValue : '') + "\u3011");
    }));
};
export var calcDiffText = function (diffTexts) {
    return "```\u25A0 \u5909\u66F4\u5DEE\u5206\n" + diffTexts.join('\n') + "```";
};
